import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RelativeDatePipe } from '@app/pipes/relative-date.pipe';
import { _, TranslatePipe } from '@ngx-translate/core';

import { DecisionListWidgetComponent } from '../decision-list-widget/decision-list-widget.component';
import { useDecisionList } from '../decision-list-widget/use-decision-list';
import { toPendingHireRow } from './pending-hire-row';
import { PendingHiresApiService } from './pending-hires-api.service';

@Component({
  selector: 'new-hires-widget',
  templateUrl: './new-hires-widget.component.html',
  imports: [DecisionListWidgetComponent, TranslatePipe, RelativeDatePipe, RouterLink],
})
export class NewHiresWidgetComponent {
  #api = inject(PendingHiresApiService);

  list = useDecisionList({
    load: () => this.#api.list(),
    toRows: (newHires) => newHires.rows.map(toPendingHireRow).filter((row) => row !== null),
  });

  badgeLabel = computed(() => (this.list.count() ? _('[count] in progress') : _('None in progress')));
}
